import React, { useMemo } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid/models/params/gridCellParams';
import UserTeamsRoles from './user-teams-roles';
import { convertTeamsPermissions } from '../helpers';
import { PermissionsTeam, TeamMinimized } from '../types';

interface Props {
  appTeams: TeamMinimized[];
  params: GridRenderCellParams;
}

const EditUserRow = ({ appTeams, params }: Props) => {
  const permissionsTeam = useMemo(
    () => (params.row.teams ? convertTeamsPermissions(params.row.teams) : ({} as PermissionsTeam)),
    [params.row.teams]
  );

  return <UserTeamsRoles appTeams={appTeams} permissionsTeam={permissionsTeam} />;
};

export default EditUserRow;
